/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_75b705d9","_75b705d9",""]'><div :class='["picker-wrapper","_75b705d9",""]'><div :class='["picker-demo-title","_75b705d9",""]'>basic-picker:</div><cube-picker :list="(dataList)" :selected-index="(selectedIndex)" @columnChange='(e)=>__invoke(e, [["onColumnChange"]])' @change='(e)=>__invoke(e, [["onChange"]])' :class='["","_75b705d9",""]'/><div :class='["event-params","_75b705d9",""]' v-if="(changeParams.length)"><div :class='["key","_75b705d9",""]'>columnChange 事件参数：</div><div :class='["value","_75b705d9",""]'><div v-for="(item, index) in (columnChangeParams)" :key="item.index" :class='["value-item","_75b705d9",""]'><div :class='["item-key","_75b705d9",""]'>{{item[0]}}</div><div :class='["item-value","_75b705d9",""]'>{{item[1]}}</div></div></div><div :class='["key","_75b705d9",""]'>change 事件参数：</div><div :class='["value","_75b705d9",""]'><div v-for="(item, index) in (changeParams)" :key="item.index" :class='["value-item","_75b705d9",""]'><div :class='["item-key","_75b705d9",""]'>{{item[0]}}</div><div :class='["item-value","_75b705d9",""]'>{{item[1]}}</div></div></div></div></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"scoped":true,"mid":"_75b705d9"}'>
.picker-demo-title
  margin-bottom: 8px
.event-params,
.demo-data
  margin-top: 10px
  padding: 10px 10px
  background-color: white
  border: 1px solid  white
  border-radius: 10px

.key
  margin-bottom: 10px
  font-size: 16px
.key-introduce
  margin-bottom: 10px
  line-height: 20px
.value
  margin-bottom: 20px
  white-space: break-spaces
  .value-item
    display flex
    justify-content: space-between
    height: 25px
    line-height: 25px
    font-size: 15px
    .item-value
      white-space nowrap
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_75b705d9"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_75b705d9"}
  /** script content **/
  require("./basic-picker.mpx.js?isComponent&outputPath=components%2Fbasic-picker75b705d9%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./basic-picker.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fbasic-picker75b705d9%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_75b705d9"],
    ctorType: "component",
    outputPath: "components/basic-picker75b705d9/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-picker':getComponent(require("../../../packages/mpx-cube-ui/src/components/picker/index.mpx?isComponent&outputPath=components%2Findex3b508115%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>